import { Alert, AlertTitle } from '@mui/material'
import type React from 'react'

import type { ErrorContext } from '@/lib/apollo/utils/getUpstreamErrors'

interface Props {
  errors: ErrorContext<string>[]
}

const ErrorList: React.FC<Props> = ({ errors }) => {
  return (
    <Alert severity="error">
      <AlertTitle>There was an error submitting the information provided.</AlertTitle>
      {errors.length > 0 ? (
        <ol>
          {errors.map(({ description, reason }, i) => (
            <li key={i}>
              {description} - ({reason})
            </li>
          ))}
        </ol>
      ) : (
        <span>Please try again</span>
      )}
    </Alert>
  )
}

export default ErrorList
